import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=54c3b1e7&scoped=true&"
import script from "./search-bar.vue?vue&type=script&lang=js&"
export * from "./search-bar.vue?vue&type=script&lang=js&"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=54c3b1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3b1e7",
  null
  
)

export default component.exports